import { Form, Validators, field } from "fw-model";
const { required } = Validators;

export class ConfirmChangeEmailAction {
    constructor(
        public form: ConfirmChangeEmailForm,
        public token: string
    ) {}
}

export class ConfirmChangeEmailForm extends Form {
    @field("Password", required)
    public Password: string = null;
}
